// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/images/yeyeldenRING.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/images/nokroneldenring.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/Mantinia.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Style for the banner in the top navbar*/
.navbar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 120%;
  background-position: center;
  background-position-y: 15%;
}
/* some style for the youtube video, adding distance to the other elements and so on,  
the video: https://www.youtube.com/watch?v=E3Huy2cdih0 
w3schools youtube embedding: https://www.w3schools.com/html/html_youtube.asp*/
.youTubeEmbed {
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}
/*For small text in the style of trademark-type-writings, used on the text under the youtube video on homepage*/
.smallText {
  font-family: sans-serif;
  color: #de9c62;
  font-size: small;
}
/*Effects of a glow and slight animation for the logo in the top left of the navbar*/
.logoImageEffects {
  transition: all 0.3s ease;
  border-radius: 50%;
}

/*Makes the logo swivel and expand on hover*/
.logoImageEffects:hover {
  box-shadow: 0 0 10px 5px #de9c62;
  cursor: pointer;
  transform: scale(1.05);
  animation: swivel 0.5s ease;
}
/*A slight pop back when clicked on*/
.logoImageEffects:active {
  transform: scale(0.95);
}
/*A slight swivel animation for the logo in the navbar,found out how to do this from chatgpt*/
@keyframes swivel {
  0% {
    transform: rotate(0deg) scale(1.05);
  }
  25% {
    transform: rotate(10deg) scale(1.05);
  }
  50% {
    transform: rotate(-10deg) scale(1.05);
  }
  75% {
    transform: rotate(5deg) scale(1.05);
  }
  100% {
    transform: rotate(0deg) scale(1.05);
  }
}
/*Some previous inlined styles changed to css classes --------------------------------*/
/* makes a css class from a previous inlined styles for the divs in the navbar */
.flexCenterRelative {
  display: flex;
  align-items: center;
  position: relative;
}
.menuDiv {
  padding: 5px;
  cursor: pointer;
}
/*Style for when the search bar shows no results*/
.searchNoResult {
  padding: 5px;
  color: #888;
}
/*Specifics for view-article images*/
.currentPicture {
  width: 100px;
  height: auto;
}
/*Style for your current profile picture*/
.currentProfilePicture {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid black;
}
/*A generic black background for the furthest divs to hide the white that would appear at the back edges*/
.blackBackground {
  background-color: black;
  color: #de9c62;
  min-height: 100vh;
}

/*Image of a pretty starry background as seen in nokron in elden ring with accompanying styles*/
.nokronBG {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 150%;
  color: #de9c62;
  font-family: 'Mantinia', sans-serif;
  font-size: xx-large;
}
/**/
.blackBackgroundLogin {
  background-color: black;
  color: #de9c62;
  font-family: 'Mantinia', sans-serif;
  font-size: xx-large;
}
/**/
.divLoginBlack {
  font-family: sans-serif;
  color: #de9c62;
  font-size: large;
  background-color: black;
}
/**/
.divLoginBlackWithBorder {
  font-family: sans-serif;
  color: #de9c62;
  font-size: large;
  background-color: black;
  border-color: #de9c62;
}
/*A font we downloaded to be more in line with the elden ring font, mantinia 
downloaded from: https://font.download/font/mantinia*/
@font-face {
  font-family: 'Mantinia';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  font-weight: normal;
  font-style: normal;
}
/*Basic fontstyle with colors*/
.FontStyle {
  font-family: 'Mantinia', sans-serif;
  color: #de9c62;
  font-size: x-large;
}
/*Basic fontstyle but centered*/
.CenteredFontStyle {
  font-family: 'Mantinia', sans-serif;
  color: #de9c62;
  background-color: black;
  font-size: xx-large;
  justify-content: center;
  align-items: center;
  border-color: #de9c62;
}
/*Adds italics to text*/
.fontStyleItalic {
  font-style: italic;
}
/*Used for certain buttons and also the searchbar*/
.TransparentSearch {
  background-color: rgba(255, 255, 255, 0.1);
  color: #de9c62;
  border: none;
  font-family: 'Mantinia', sans-serif;
}
.whiteBar {
  background-color: rgba(255, 255, 255, 0.5);
  color: #de9c62;
  border: #de9c62;
}
/*Styles for positioning images on pages ---------------------------------*/
/*Style used for centering the large wikilogo on the homepage*/
.centeredImage {
  display: flex;
  justify-content: center;
  align-items: center;
}
/*Style used for correctly positioning the logo on the login-page*/
.centeredLogo {
  display: block;
  margin: 0 auto;
  position: absolute;
  top: 82%;
  left: 50%;
  transform: translate(-50%, -50%);
} /*Style for positioning an image to the right of the screen*/
.right-side-image {
  position: sticky;
  margin-left: auto;
  transform: translateY(-50%);
  width: 600px;
  height: auto;
  padding: 10px;
  border-radius: 15%;
}
/*Styles for some of our basic cards --------------------------*/
/*Style for the basic black cards*/
.basicCard {
  color: #de9c62;
  background-color: black;
  border-color: #de9c62;
}
/*Style for the basic turquoise cards*/
.TurquoiseCard {
  color: #de9c62;
  background-color: #193330;
  border-color: #de9c62;
}
/*a variant of the turquoise card that required the font applied*/
.TurquoiseCardWithFont {
  color: #de9c62;
  background-color: #193330;
  border-color: #de9c62;
  font-family: sans-serif;
}
/*accompanies the style above, but applies only to the h3 within it*/
.TurquoiseCardWithFont h3 {
  font-family: 'Mantinia', sans-serif;
}
/*A card with no accompanying style, complete darkness*/
.totalBlackCard {
  background-color: black;
}
/*Style for buttonsuccess, aka. our turquoise button*/
.buttonTurquoise {
  background-color: #193330;
  color: #de9c62;
  border-color: #de9c62;
}
/*Style for buttondanger, aka. our red button*/
.buttonRed {
  background-color: #3b130a;
  color: #de9c62;
  border-color: #de9c62;
}
/*Style for buttonBlack, aka. our black button*/
.buttonBlack {
  background-color: #030100cc;
  color: #de9c62;
  border-color: #de9c62;
}
/*Sets link color to generally be yellow*/
a {
  color: #c7a316e0;
  text-decoration: underline;
}
/*For when ones mouse hovers over*/
a:hover {
  color: #d5c997e0;
  cursor: pointer;
}
/*Sets the Font and style of the h3-headers*/
h3 {
  font-family: 'Mantinia', sans-serif;
  color: #de9c62;
  font-size: x-large;
}
/*The effects and style of the profile image plus username in the top navbar*/
.profilEffects {
  font-family: 'Mantinia', sans-serif;
  color: #de9c62 !important;
  font-size: x-large;
  transition: all 0.3s ease;
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
}
/*For when ones mouse hovers over the icon*/
.profilEffects:hover {
  box-shadow: 0 0 10px 5px #de9c62;
  cursor: pointer;
  color: #e4b892;
  transform: scale(1.03);
}
/*for when one clicks the icon*/
.profilEffects:active {
  transform: scale(1);
  color: #dcbf82;
}
/*styles making the alerts look like elden rings "you died" and "great enemy felled" messages ------------------*/
/*The base style for the alerts that applies to all*/
.alertStyle {
  padding: 15px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid transparent;
  font-size: 36px;
  font-weight: bold;
  position: relative;
  transition: all 0.3s ease;
  font-family: garamond;
  text-align: center;
  position: fixed;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  width: 120%;
  max-width: 2000px;
}
.alert-success {
  background-color: rgba(0, 0, 0, 0.8);
  color: #e0cc2e;
}
.alert-info {
  background-color: rgba(0, 0, 0, 0.8);
  color: aquamarine;
}
.alert-warning {
  background-color: rgba(0, 0, 0, 0.8);
  color: #8d120e;
}
.alert-danger {
  background-color: rgba(0, 0, 0, 0.8);
  color: #8d120e;
}
/* styles for the quill editor-------------- */
/*The editor itself, when writing for an article*/
#editor {
  color: black;
  background-color: white;
}
/*The content from the editor when displayed after*/
#quill-content {
  color: rgb(192, 185, 185);
  background-color: black !important;
}
#quill-content * {
  color: inherit !important;
  background-color: inherit !important;
}
#quill-content a {
  color: #d2c17ce0 !important;
}

/*Style for the taglinks ----------------*/
/* makes a button into text link. using this instead of navlink because of appearance preferences */
.tagLinks {
  background: none;
  border: none;
  color: #c7a316e0;
  text-decoration: solid;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: inline;
  display: inline-block;
  transition:
    transform 0.3s ease,
    color 0.3s ease;
}
/* makes the tag names bigger and in front of everything else when hovered (and changing color)   */
.tagLinks:hover {
  color: #c7a316e0;
  transform: scale(1.05);
  z-index: 10;
}
.tagLinks::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #de9c62;
  transition: width 0.3s ease;
}
.tagLinks:hover::after {
  width: 100%;
}
/* Specifies presentation for the images used in articles */
.articleImage img {
  width: 20%;
  border-radius: 8px;
  margin-bottom: 10px;
}
/*Style for displaying different versions by different authors on viewarticle  page*/
.articleVersions {
  height: 100%;
  min-height: 720px;
  display: grid;
  grid-template-rows: 1fr auto;
}
/*Style used to show profile pictures of the people who have written comments*/
.commentProfilePicture {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid black;
  object-fit: cover;
  transition:
    transform 0.3s ease,
    width 0.3s ease,
    height 0.3s ease;
}
/*When hovering over the profile pictures*/
.commentProfilePicture:hover {
  width: 55px;
  height: 55px;
  transform: scale(1.2);
  cursor: pointer;
}
/*The "appraisal bar on the view article page"*/
/* CSS used gotten from this video: https://www.youtube.com/watch?v=basf1lH1H-E, but changed for our purposes */
.progress-bar {
  position: relative;
  width: 175px; /* Adjusted size */
  height: 1.05em;
  background-color: rgb(153, 35, 25); /* Unfilled part is red */
  border: 2px solid black; /* Black border around the bar */
  border-radius: 0.525em;
  color: rgb(15, 14, 14);
  box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.4); /* Shadow for a glowing border effect */
}
.progress-bar::before {
  content: attr(data-label);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: calc(var(--width, 0) * 1%);
  background-color: rgb(12, 107, 12);
  border-radius: 0.525em 0 0 0.525em;
  color: rgb(17, 16, 16);
  border-right: 2px solid rgba(17, 16, 16, 0.8);
  box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.4);
}
`, "",{"version":3,"sources":["webpack://./src/styles/wiki.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,yDAA+D;EAC/D,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;;6EAE6E;AAC7E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA,+GAA+G;AAC/G;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA,oFAAoF;AACpF;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;AACA,oCAAoC;AACpC;EACE,sBAAsB;AACxB;AACA,6FAA6F;AAC7F;EACE;IACE,mCAAmC;EACrC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;AACF;AACA,uFAAuF;AACvF,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA,iDAAiD;AACjD;EACE,YAAY;EACZ,WAAW;AACb;AACA,oCAAoC;AACpC;EACE,YAAY;EACZ,YAAY;AACd;AACA,yCAAyC;AACzC;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;AACA,yGAAyG;AACzG;EACE,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA,+FAA+F;AAC/F;EACE,yDAAkE;EAClE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;EACnC,mBAAmB;AACrB;AACA,GAAG;AACH;EACE,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,mBAAmB;AACrB;AACA,GAAG;AACH;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;AACA,GAAG;AACH;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;qDACqD;AACrD;EACE,uBAAuB;EACvB,+DAAyD;EACzD,mBAAmB;EACnB,kBAAkB;AACpB;AACA,8BAA8B;AAC9B;EACE,mCAAmC;EACnC,cAAc;EACd,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,mCAAmC;EACnC,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;AACA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;AACA,kDAAkD;AAClD;EACE,0CAA0C;EAC1C,cAAc;EACd,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,0CAA0C;EAC1C,cAAc;EACd,eAAe;AACjB;AACA,2EAA2E;AAC3E,8DAA8D;AAC9D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA,kEAAkE;AAClE;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC,EAAE,4DAA4D;AAC9D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA,gEAAgE;AAChE,kCAAkC;AAClC;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;AACvB;AACA,sCAAsC;AACtC;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA,iEAAiE;AACjE;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;AACA,oEAAoE;AACpE;EACE,mCAAmC;AACrC;AACA,uDAAuD;AACvD;EACE,uBAAuB;AACzB;AACA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;AACvB;AACA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA,4CAA4C;AAC5C;EACE,mCAAmC;EACnC,cAAc;EACd,kBAAkB;AACpB;AACA,6EAA6E;AAC7E;EACE,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,2CAA2C;AAC3C;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;AACA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,iHAAiH;AACjH,oDAAoD;AACpD;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA,8CAA8C;AAC9C,iDAAiD;AACjD;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C,mGAAmG;AACnG;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB;;mBAEiB;AACnB;AACA,mGAAmG;AACnG;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA,2DAA2D;AAC3D;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;AACA,oFAAoF;AACpF;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,4BAA4B;AAC9B;AACA,8EAA8E;AAC9E;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB;;;oBAGkB;AACpB;AACA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;AACA,+CAA+C;AAC/C,+GAA+G;AAC/G;EACE,kBAAkB;EAClB,YAAY,EAAE,kBAAkB;EAChC,cAAc;EACd,kCAAkC,EAAE,yBAAyB;EAC7D,uBAAuB,EAAE,gCAAgC;EACzD,sBAAsB;EACtB,sBAAsB;EACtB,gDAAgD,EAAE,uCAAuC;AAC3F;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,6CAA6C;EAC7C,gDAAgD;AAClD","sourcesContent":["/*Style for the banner in the top navbar*/\n.navbar-background {\n  background-image: url('/public/images/images/yeyeldenRING.png');\n  background-size: 120%;\n  background-position: center;\n  background-position-y: 15%;\n}\n/* some style for the youtube video, adding distance to the other elements and so on,  \nthe video: https://www.youtube.com/watch?v=E3Huy2cdih0 \nw3schools youtube embedding: https://www.w3schools.com/html/html_youtube.asp*/\n.youTubeEmbed {\n  margin-top: 30px;\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: center;\n}\n/*For small text in the style of trademark-type-writings, used on the text under the youtube video on homepage*/\n.smallText {\n  font-family: sans-serif;\n  color: #de9c62;\n  font-size: small;\n}\n/*Effects of a glow and slight animation for the logo in the top left of the navbar*/\n.logoImageEffects {\n  transition: all 0.3s ease;\n  border-radius: 50%;\n}\n\n/*Makes the logo swivel and expand on hover*/\n.logoImageEffects:hover {\n  box-shadow: 0 0 10px 5px #de9c62;\n  cursor: pointer;\n  transform: scale(1.05);\n  animation: swivel 0.5s ease;\n}\n/*A slight pop back when clicked on*/\n.logoImageEffects:active {\n  transform: scale(0.95);\n}\n/*A slight swivel animation for the logo in the navbar,found out how to do this from chatgpt*/\n@keyframes swivel {\n  0% {\n    transform: rotate(0deg) scale(1.05);\n  }\n  25% {\n    transform: rotate(10deg) scale(1.05);\n  }\n  50% {\n    transform: rotate(-10deg) scale(1.05);\n  }\n  75% {\n    transform: rotate(5deg) scale(1.05);\n  }\n  100% {\n    transform: rotate(0deg) scale(1.05);\n  }\n}\n/*Some previous inlined styles changed to css classes --------------------------------*/\n/* makes a css class from a previous inlined styles for the divs in the navbar */\n.flexCenterRelative {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.menuDiv {\n  padding: 5px;\n  cursor: pointer;\n}\n/*Style for when the search bar shows no results*/\n.searchNoResult {\n  padding: 5px;\n  color: #888;\n}\n/*Specifics for view-article images*/\n.currentPicture {\n  width: 100px;\n  height: auto;\n}\n/*Style for your current profile picture*/\n.currentProfilePicture {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid black;\n}\n/*A generic black background for the furthest divs to hide the white that would appear at the back edges*/\n.blackBackground {\n  background-color: black;\n  color: #de9c62;\n  min-height: 100vh;\n}\n\n/*Image of a pretty starry background as seen in nokron in elden ring with accompanying styles*/\n.nokronBG {\n  background-image: url('/public/images/images/nokroneldenring.jpg');\n  background-size: 150%;\n  color: #de9c62;\n  font-family: 'Mantinia', sans-serif;\n  font-size: xx-large;\n}\n/**/\n.blackBackgroundLogin {\n  background-color: black;\n  color: #de9c62;\n  font-family: 'Mantinia', sans-serif;\n  font-size: xx-large;\n}\n/**/\n.divLoginBlack {\n  font-family: sans-serif;\n  color: #de9c62;\n  font-size: large;\n  background-color: black;\n}\n/**/\n.divLoginBlackWithBorder {\n  font-family: sans-serif;\n  color: #de9c62;\n  font-size: large;\n  background-color: black;\n  border-color: #de9c62;\n}\n/*A font we downloaded to be more in line with the elden ring font, mantinia \ndownloaded from: https://font.download/font/mantinia*/\n@font-face {\n  font-family: 'Mantinia';\n  src: url('/public/fonts/Mantinia.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n/*Basic fontstyle with colors*/\n.FontStyle {\n  font-family: 'Mantinia', sans-serif;\n  color: #de9c62;\n  font-size: x-large;\n}\n/*Basic fontstyle but centered*/\n.CenteredFontStyle {\n  font-family: 'Mantinia', sans-serif;\n  color: #de9c62;\n  background-color: black;\n  font-size: xx-large;\n  justify-content: center;\n  align-items: center;\n  border-color: #de9c62;\n}\n/*Adds italics to text*/\n.fontStyleItalic {\n  font-style: italic;\n}\n/*Used for certain buttons and also the searchbar*/\n.TransparentSearch {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #de9c62;\n  border: none;\n  font-family: 'Mantinia', sans-serif;\n}\n.whiteBar {\n  background-color: rgba(255, 255, 255, 0.5);\n  color: #de9c62;\n  border: #de9c62;\n}\n/*Styles for positioning images on pages ---------------------------------*/\n/*Style used for centering the large wikilogo on the homepage*/\n.centeredImage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/*Style used for correctly positioning the logo on the login-page*/\n.centeredLogo {\n  display: block;\n  margin: 0 auto;\n  position: absolute;\n  top: 82%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n} /*Style for positioning an image to the right of the screen*/\n.right-side-image {\n  position: sticky;\n  margin-left: auto;\n  transform: translateY(-50%);\n  width: 600px;\n  height: auto;\n  padding: 10px;\n  border-radius: 15%;\n}\n/*Styles for some of our basic cards --------------------------*/\n/*Style for the basic black cards*/\n.basicCard {\n  color: #de9c62;\n  background-color: black;\n  border-color: #de9c62;\n}\n/*Style for the basic turquoise cards*/\n.TurquoiseCard {\n  color: #de9c62;\n  background-color: #193330;\n  border-color: #de9c62;\n}\n/*a variant of the turquoise card that required the font applied*/\n.TurquoiseCardWithFont {\n  color: #de9c62;\n  background-color: #193330;\n  border-color: #de9c62;\n  font-family: sans-serif;\n}\n/*accompanies the style above, but applies only to the h3 within it*/\n.TurquoiseCardWithFont h3 {\n  font-family: 'Mantinia', sans-serif;\n}\n/*A card with no accompanying style, complete darkness*/\n.totalBlackCard {\n  background-color: black;\n}\n/*Style for buttonsuccess, aka. our turquoise button*/\n.buttonTurquoise {\n  background-color: #193330;\n  color: #de9c62;\n  border-color: #de9c62;\n}\n/*Style for buttondanger, aka. our red button*/\n.buttonRed {\n  background-color: #3b130a;\n  color: #de9c62;\n  border-color: #de9c62;\n}\n/*Style for buttonBlack, aka. our black button*/\n.buttonBlack {\n  background-color: #030100cc;\n  color: #de9c62;\n  border-color: #de9c62;\n}\n/*Sets link color to generally be yellow*/\na {\n  color: #c7a316e0;\n  text-decoration: underline;\n}\n/*For when ones mouse hovers over*/\na:hover {\n  color: #d5c997e0;\n  cursor: pointer;\n}\n/*Sets the Font and style of the h3-headers*/\nh3 {\n  font-family: 'Mantinia', sans-serif;\n  color: #de9c62;\n  font-size: x-large;\n}\n/*The effects and style of the profile image plus username in the top navbar*/\n.profilEffects {\n  font-family: 'Mantinia', sans-serif;\n  color: #de9c62 !important;\n  font-size: x-large;\n  transition: all 0.3s ease;\n  border-radius: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n/*For when ones mouse hovers over the icon*/\n.profilEffects:hover {\n  box-shadow: 0 0 10px 5px #de9c62;\n  cursor: pointer;\n  color: #e4b892;\n  transform: scale(1.03);\n}\n/*for when one clicks the icon*/\n.profilEffects:active {\n  transform: scale(1);\n  color: #dcbf82;\n}\n/*styles making the alerts look like elden rings \"you died\" and \"great enemy felled\" messages ------------------*/\n/*The base style for the alerts that applies to all*/\n.alertStyle {\n  padding: 15px;\n  margin: 10px 0;\n  border-radius: 5px;\n  border: 1px solid transparent;\n  font-size: 36px;\n  font-weight: bold;\n  position: relative;\n  transition: all 0.3s ease;\n  font-family: garamond;\n  text-align: center;\n  position: fixed;\n  top: 42%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1050;\n  width: 120%;\n  max-width: 2000px;\n}\n.alert-success {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #e0cc2e;\n}\n.alert-info {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: aquamarine;\n}\n.alert-warning {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #8d120e;\n}\n.alert-danger {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #8d120e;\n}\n/* styles for the quill editor-------------- */\n/*The editor itself, when writing for an article*/\n#editor {\n  color: black;\n  background-color: white;\n}\n/*The content from the editor when displayed after*/\n#quill-content {\n  color: rgb(192, 185, 185);\n  background-color: black !important;\n}\n#quill-content * {\n  color: inherit !important;\n  background-color: inherit !important;\n}\n#quill-content a {\n  color: #d2c17ce0 !important;\n}\n\n/*Style for the taglinks ----------------*/\n/* makes a button into text link. using this instead of navlink because of appearance preferences */\n.tagLinks {\n  background: none;\n  border: none;\n  color: #c7a316e0;\n  text-decoration: solid;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  display: inline;\n  display: inline-block;\n  transition:\n    transform 0.3s ease,\n    color 0.3s ease;\n}\n/* makes the tag names bigger and in front of everything else when hovered (and changing color)   */\n.tagLinks:hover {\n  color: #c7a316e0;\n  transform: scale(1.05);\n  z-index: 10;\n}\n.tagLinks::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background-color: #de9c62;\n  transition: width 0.3s ease;\n}\n.tagLinks:hover::after {\n  width: 100%;\n}\n/* Specifies presentation for the images used in articles */\n.articleImage img {\n  width: 20%;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n/*Style for displaying different versions by different authors on viewarticle  page*/\n.articleVersions {\n  height: 100%;\n  min-height: 720px;\n  display: grid;\n  grid-template-rows: 1fr auto;\n}\n/*Style used to show profile pictures of the people who have written comments*/\n.commentProfilePicture {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid black;\n  object-fit: cover;\n  transition:\n    transform 0.3s ease,\n    width 0.3s ease,\n    height 0.3s ease;\n}\n/*When hovering over the profile pictures*/\n.commentProfilePicture:hover {\n  width: 55px;\n  height: 55px;\n  transform: scale(1.2);\n  cursor: pointer;\n}\n/*The \"appraisal bar on the view article page\"*/\n/* CSS used gotten from this video: https://www.youtube.com/watch?v=basf1lH1H-E, but changed for our purposes */\n.progress-bar {\n  position: relative;\n  width: 175px; /* Adjusted size */\n  height: 1.05em;\n  background-color: rgb(153, 35, 25); /* Unfilled part is red */\n  border: 2px solid black; /* Black border around the bar */\n  border-radius: 0.525em;\n  color: rgb(15, 14, 14);\n  box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.4); /* Shadow for a glowing border effect */\n}\n.progress-bar::before {\n  content: attr(data-label);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: calc(var(--width, 0) * 1%);\n  background-color: rgb(12, 107, 12);\n  border-radius: 0.525em 0 0 0.525em;\n  color: rgb(17, 16, 16);\n  border-right: 2px solid rgba(17, 16, 16, 0.8);\n  box-shadow: inset 0px 0px 6px rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
